export default "__VITE_ASSET__CSfO0HvE__"